import React, { useEffect, useState } from 'react';
import LinkGoogleModal from './LinkGoogleModal';
import LoadingScreen from './LoadingScreen';
import { userNeedsGoogleLink } from '../utils/authLinking';

/**
 * Web dashboard gate: phone-only accounts (mobile app users on web) must link Gmail.
 * Skips users who already have Google or email/password linked.
 */
export default function GoogleLinkGate({ user, refreshUser, children }) {
  const [checking, setChecking] = useState(true);
  const [needsLink, setNeedsLink] = useState(false);

  useEffect(() => {
    if (!user) {
      setNeedsLink(false);
      setChecking(false);
      return;
    }

    setNeedsLink(userNeedsGoogleLink(user));
    setChecking(false);
  }, [user]);

  if (checking) return <LoadingScreen />;
  if (user && needsLink) return <LinkGoogleModal onLinked={refreshUser} />;
  return children;
}
